import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {UnitModel} from '../../unit/unit.model';
import {Observable, of} from 'rxjs';
import {UnitGroupModel} from '../../unit/unit-group/unit-group.model';

@Injectable({
  providedIn: 'root'
})
export class UnitGroupsService {

  constructor(
    private http: HttpClient
  ) { }

  public getGroupsOfUnit(unitId: number): Observable<UnitGroupModel[]> {
    const params: HttpParams = (new HttpParams())
      .append(
        'fields',
        [
          'unitGroups.id',
          'unitGroups.name',
        ].join(',')
      )
      .append(
        'expand',
        [
          'unitGroups',
          'unitGroups.region_name',
          'unitGroups.country_name',
        ].join(',')
      );
    return this.http.get<UnitModel>(
      environment.apiBasepoint + 'unit/' + unitId.toString(),
      {
        params: params,
        observe: 'body'
      }
    ).pipe(
      map(
        unit => unit.unitGroups
      )
    );
  }

  public addUnitToGroup(unitId: number, groupId: number): Observable<boolean> {
    return this.http.post<{success: boolean}>(
      environment.apiBasepoint + 'add-unit-to-group',
      {
        unitId: unitId,
        unitGroupId: groupId,
      },
      {observe: 'body'}
    ).pipe(
      catchError(
        () => of({success: false}),
      ),
      map(
        result => result.success
      )
    );
  }
  public removeUnitFromGroup(unitId: number, groupId: number): Observable<boolean> {
    return this.http.post<{success: boolean}>(
      environment.apiBasepoint + 'remove-unit-from-group',
      {
        unitId: unitId,
        unitGroupId: groupId,
      },
      {observe: 'body'}
    ).pipe(
      catchError(
        () => of({success: false}),
      ),
      map(
        result => result.success
      )
    );
  }
}
